// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-hero__image.video-hero__image--mobile {
  display: none;
}

@media (max-width: 719px) {
  .video-hero__image.video-hero__image--mobile {
    display: block;
  }
}
@media (max-width: 719px) {
  .video-hero__image.video-hero__image--mobile + .video-hero__image {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/styles/video-hero.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE;IACE,cAAA;EACF;AACF;AAEA;EACE;IACE,aAAA;EAAF;AACF","sourcesContent":[".video-hero__image.video-hero__image--mobile {\n  display: none;\n}\n\n@media (max-width: 719px) {\n  .video-hero__image.video-hero__image--mobile {\n    display: block;\n  }\n}\n\n@media (max-width: 719px) {\n  .video-hero__image.video-hero__image--mobile + .video-hero__image {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
